import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LayoutAppComponent } from './core/page/layout-app/layout-app.component';
import { LayoutLoginComponent } from './core/page/layout-login/layout-login.component';

export const APP_ROUTES: Routes = [
   { path: '', pathMatch: 'full', redirectTo: 'login' },
   {
      path: '',
      component: LayoutLoginComponent,
      children: [
         {
            path: 'login',
            loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
         },
         {
            path: 'novo-cliente',
            loadComponent: () => import('./pages/new-customer/new-customer.page').then((m) => m.NewCustomerPage),
         },
         {
            path: 'confirmar-cliente',
            loadComponent: () => import('./pages/customer-confirm/customer-confirm.page').then((m) => m.CustomerConfirmPage),
         },
         {
            path: 'confirmar-email',
            loadComponent: () => import('./pages/email-confirmation/email-confirmation.page').then((m) => m.EmailConfirmationPage),
         },
         {
            path: 'redefinir-senha',
            loadComponent: () => import('./pages/password-reset/password-reset.page').then((m) => m.PasswordResetPage),
         },
      ],
   },
   {
      path: '',
      canActivate: [authGuard],
      component: LayoutAppComponent,
      children: [
         {
            path: 'inicio',
            loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
         },
         {
            path: 'empresas',
            loadComponent: () => import('./pages/companies/companies.page').then((m) => m.CompaniesPage),
         },
         {
            path: 'empresas/:id',
            loadComponent: () => import('./pages/company-detail/company-detail.page').then((m) => m.CompanyDetailPage),
         },
         {
            path: 'beneficios',
            loadComponent: () => import('./pages/benefits/benefits.page').then((m) => m.BenefitsPage),
         },
         {
            path: 'resgates',
            loadComponent: () => import('./pages/redemptions/redemptions.page').then((m) => m.RedemptionsPage),
         },
         {
            path: 'perfil/dados',
            loadComponent: () => import('./pages/profile/personal-data/personal-data.page').then((m) => m.PersonalDataPage),
         },
         {
            path: 'perfil/senha',
            loadComponent: () => import('./pages/profile/change-password/change-password.page').then((m) => m.ChangePasswordPage),
         },
         {
            path: 'perfil/configuracoes',
            loadComponent: () => import('./pages/profile/settings/settings.page').then((m) => m.SettingsPage),
         },
         {
            path: 'perfil',
            loadComponent: () => import('./pages/profile/profile.page').then((m) => m.ProfilePage),
         },
      ],
   },
   { path: '**', redirectTo: 'login' },
];
